module.exports = __webpack_public_path__ + "static/media/66.cea0aef5.gif";